﻿import { defineComponent, PropType, toDisplayString, useSSRContext } from 'vue';
import itinerary from "../../base/common/itinerary.vue";
import VLazyImage from "v-lazy-image";

import { product_search_product } from '../../../objects/v1_3/product/search/product_search_product';

import { Booking } from "../../../services/booking";
import { Product } from "../../../services/product";
import { Currency_Service } from "../../../../system/services/currency";

const Book = new Booking();
const Prod = new Product();
const Currency_Services = new Currency_Service();

export default defineComponent({
    name: "tour_card",
    emits: [
        "bookTour"
    ],
    components: {
        itinerary,
        VLazyImage
    },
    props: {
        "tour_details": {type: Object as PropType<product_search_product>, default: new product_search_product()},
        OpenBooking: Boolean,
        InCart: Boolean

    },
    data() {
        return {
            isHidden: true as boolean,
            tour_id: "" as string,
            loadingOpenTour: false as boolean
        }
    },
    methods: {
        tour_see_details(tour_id: string) {

            this.tour_id = tour_id;
            this.isHidden = false;
            this.$refs.itinerary?.download_product(tour_id);
        },
        tour_selected() {
            if(Prod.product_pricing(Book.Pricing_Age_Category(this.$store), this.$store.getters.get_Currency, this.tour_details ?? new product_search_product()) > 0){
                this.$emit("bookTour", this.tour_details?.tour_id);
            }
        },
        useSalesGroupDisplay(): boolean {
            if (import.meta.env.VITE_USE_SALES_GROUP_DISPLAY === "true") {
                return true;
            }
            return false;
        },
        getSalesGroupName(tour_details: product_search_product): string {
            let groupName = "";
            if (tour_details?.name != null) {
                groupName = tour_details.name;
            }
            if(this.useSalesGroupDisplay() &&tour_details?.sales_group?.sales_group_display_name != null && tour_details?.sales_group?.sales_group_display_name != ""){
                groupName = tour_details.sales_group.sales_group_display_name;
            }

            if((groupName == null || groupName == "") && (tour_details.name_short != null && tour_details.name_short != "")){
                groupName = tour_details.name_short;
            }
            return groupName;
        },
        // products without a length (e.g. gift vouchers) hide the length and accommodation badges
        Has_Length(): boolean {
            const duration = this.tour_details?.duration;
            return (duration?.days ?? 0) > 0 || (duration?.hours ?? 0) > 0 || (duration?.minutes ?? 0) > 0;
        },
        Includes_Accommodation(): boolean {
            return this.Has_Length() && !this.isAAT() && this.durationInDays().toUpperCase().includes('DAYS');
        },
        Departure_City(): string {
            return this.tour_details?.start_location?.city || this.tour_details?.start_location?.title || "";
        },
        // No longer used: OpenBooking is never passed in; ?open= is handled by 1_search.ts (maybeOpenFromQueryOnce).
        // async selected_from_URL() {
        //     if(this.OpenBooking){
        //         this.loadingOpenTour = true;
        //         if(this.bookable()){
        //             this.loadingOpenTour = false;
        //             this.$emit("bookTour", this.tour_details?.tour_id);
        //         }
        //         else
        //         {
        //             await this.delay(100);
        //             this.selected_from_URL();
        //         }
        //     };
        // },
        duration(): string {
            return Prod.product_search_duration(this.tour_details ?? new product_search_product());
        },
        durationInDays(): string {
            let days = this.tour_details?.duration?.days ?? 0;
            if ((this.tour_details?.duration?.hours ?? 0) >= 1) {
                days++;
            }

            if(days == 1){
                return days.toString() + " day";
            }
            else
            {
                return days.toString() + " days";
            }
        },
        currency(): string {  
            return this.$store.getters.get_Currency.currency_info.iso_currency_code;
        },
        price(): string {
            return Currency_Services.Format_Currency(Prod.product_pricing(Book.Pricing_Age_Category(this.$store), this.$store.getters.get_Currency, this.tour_details ?? new product_search_product()), this.$store.getters.get_Currency);
        },
        image(): string {
            if (this.tour_details?.media_asset != null) {
                return this.tour_details?.media_asset?.asset_url + "?anchor=center&mode=crop&width=900";
            }

            return String(import.meta.env.VITE_DEFAULT_HERO_IMAGE);
        },
        imageAltText(): string 
        {
            return this.tour_details?.media_asset?.name ?? "Image of " + this.tour_details?.name;
        },
        imageSmall(): string {
            if (this.tour_details?.media_asset != null) {
                return this.tour_details?.media_asset?.asset_url + "?anchor=center&mode=crop&width=300&height=200";
            }

            return String(import.meta.env.VITE_DEFAULT_HERO_IMAGE);
        },
        getNotBookableText(): string {
            return "Sadly, we are currently unable to book this tour online. Please call to book: " + import.meta.env.VITE_DEFAULT_PHONE_NUMBER;
        },
        notBookableClick(tour_id: string): void {
            if(!this.bookable()){
                this.tour_see_details(tour_id)
            }

        },
        display_description(): string {
            if (this.useSalesGroupDisplay() &&this?.tour_details?.sales_group?.sales_group_display_description != null && this?.tour_details?.sales_group?.sales_group_display_description != "") {
                return this?.tour_details?.sales_group?.sales_group_display_description;
            }

            if (this?.tour_details?.description_headline != null) {
                return this.tour_details.description_headline;
            }

            let Output_Text: string = this?.tour_details?.description ?? "";
            if(this?.tour_details?.description_short != null){
                if(!this?.tour_details?.description_short.toLowerCase().includes("room =")){
                    Output_Text = this?.tour_details?.description_short + Output_Text;  
                }
            }

            if (Output_Text != null) {
                if (Output_Text.length > 61) {
                    return Output_Text.slice(0, 60).replace(/<\/?[^>]+(>|$)/g, "");
                } else {
                    return Output_Text.replace(/<\/?[^>]+(>|$)/g, "");
                }
            }
            return "A beautiful tour of Scotland.";

        },
        // No longer used: the card clamps the description to three lines in CSS (.tc-desc).
        // Format_Description(description: string): string {
        //     let formatted_description: string = description;
        //
        //     let tourdetailslength: number = -1; 
        //     if (this.tour_details != undefined) {
        //         tourdetailslength = this.tour_details.name.length;
        //     }
        //
        //     if(tourdetailslength >= 34){
        //         if (description.length > 100)
        //         {
        //             formatted_description = formatted_description.slice(0, 97) + "...";
        //         }
        //     }
        //     else
        //     {
        //         if (description.length > 140)
        //         {
        //             formatted_description = formatted_description.slice(0, 137) + "...";
        //         }
        //
        //     }
        //     return formatted_description;
        //
        // },
        getBrandLogo(): string {
            let Output_Brand_Logo: string = "";

            if (import.meta.env.VITE_LOGOS_ON_CARDS === "true") {
                if (this.tour_details?.brand && this.tour_details.brand.toUpperCase().includes("HAG")) {
                    Output_Brand_Logo = "https://contenthub.radicaltravel.com/media/2629/hagfortab.png?width=500&mode=max&animationprocessmode=first";
                } else if (this.tour_details?.brand && this.tour_details.brand.toUpperCase().includes("HEX")) {
                    Output_Brand_Logo = "https://contenthub.radicaltravel.com/media/2659/hexfortab2.jpg?width=500&mode=max&animationprocessmode=first";
                }
            }
            return Output_Brand_Logo;
        },
        isAgent_Login(): boolean {
            return this.$store.getters.get_Agent_Login?.valid_login == true;
        },
        localUrl(): boolean {
            if (window.location.href.includes("localhost")) {
                return true;
            }
            return false;
        },
        isAAT(): boolean {
            if (import.meta.env.VITE_DEFAULT_PARENT == "AAT") {
                return true;
            }
            return false;
        },
        Mapping_Codes(): string {
            let Output_Text: string = "";

            if (import.meta.env.VITE_DEFAULT_DISPLAY_TOUR_SEARCH == "true") {
                this.tour_details?.mapping_codes?.forEach((Code: string) => {
                    if (Output_Text != "") {
                        Output_Text += ", ";
                    }

                    Output_Text += Code;
                });
            }

            return Output_Text;
        },
        // No longer used: replaced by Departure_City() ("Departs Edinburgh").
        // getDepartureText(): string {
        //     if(this.tour_details.start_location.city != null && this.tour_details.start_location.city != "") {
        //         return this.tour_details.start_location.city + " departure"
        //     }
        //     else if(this.tour_details.start_location.title != null && this.tour_details.start_location.title != "") {
        //         return this.tour_details.start_location.title + " departure"
        //     }
        //     else {
        //         return ""
        //     }
        // },
        getBrand(): string {

            let Output_Brand: string = "";

            if (this.tour_details?.brand && this.tour_details.brand.toUpperCase().includes("HAG")) {
                Output_Brand = "Haggis Adventures";
            }
            else if (this.tour_details?.brand && this.tour_details.brand.toUpperCase().includes("HEX")) {
                Output_Brand = "Highland Explorer";
            }

            return Output_Brand;


        },
        bookable(): boolean {
            if(Prod.product_pricing(Book.Pricing_Age_Category(this.$store), this.$store.getters.get_Currency, this.tour_details ?? new product_search_product()) > 0){
                return true;
            }
            else
            {
                return false;
            }

        },
        // No longer used: only needed by selected_from_URL (commented out above).
        // delay(ms: number) {
        //     return new Promise( resolve => setTimeout(resolve, ms) );
        // }
    },

    mounted() {
        // this.selected_from_URL();  // see note on selected_from_URL
    }
})